import Navbar from "../general/navbar";
import ContactMap from "../contact/contactMap";
import ImageCarousel from "../general/imageCarousel";
import Footer from "../general/footer";
export default function IndexPage() {
  return (
    <div className="contact-page">
      <Navbar />
      <ContactMap />
      <ImageCarousel />
      <Footer />
    </div>
  );
}
